import { FieldType } from 'modules/domains';

export const isStringFieldType = (type?: FieldType): type is FieldType.STRING =>
  type === FieldType.STRING;
